interface RatingsIconProps {
	className?: string;
}

export function RatingsIcon({ className }: RatingsIconProps) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden="true"
		>
			<path
				d="M7.66769 13.447H5.33333V17.9924H7.66769M7.66769 13.447V17.9924M7.66769 13.447L9.56694 12.2142C9.85207 12.0292 10.0827 11.7749 10.2359 11.4764L10.5808 10.8049C10.703 10.567 10.9528 10.4167 11.226 10.4167C11.6244 10.4167 11.9474 10.7311 11.9474 11.119V11.4394C11.9474 11.7647 11.8836 12.087 11.7595 12.389L11.1692 13.8258H13.7216C14.2126 13.8258 14.5809 14.2631 14.4846 14.7319L13.9851 17.1638C13.9248 17.4571 13.7767 17.7265 13.5595 17.938L13.1813 18.3062C12.8894 18.5904 12.4936 18.75 12.0809 18.75H10.3623C9.86729 18.75 9.37688 18.658 8.91732 18.4791L7.66769 17.9924M9.919 6.77765L7.85879 7.91667L8.25234 5.5042L6.58333 3.79585L8.88656 3.44484L9.91667 1.25L10.9468 3.44484L13.25 3.79585L11.581 5.5042L11.9745 7.91667L9.919 6.77765ZM16.6711 9.5624L15.0463 10.4167L15.3567 8.60732L14.0404 7.32605L15.8568 7.0628L16.6692 5.41667L17.4816 7.0628L19.2981 7.32605L17.9818 8.60732L18.2922 10.4167L16.6711 9.5624ZM3.25175 9.60428L1.70659 10.4167L2.00175 8.69601L0.75 7.47755L2.47742 7.2272L3.25 5.66176L4.02258 7.2272L5.75 7.47755L4.49825 8.69601L4.79341 10.4167L3.25175 9.60428Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
